import { get } from '@micun/web-components'
import { Menu as AntdMenu, ConfigProvider } from 'antd'
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import type {
  ItemType,
  MenuItemGroupType,
  MenuItemType as OrgMenuItemType,
} from 'antd/es/menu/interface'
import { useCallback, useEffect, useState } from 'react'
import { Link, matchPath, useLocation } from 'react-router-dom'
import { useLayout } from '.'

// import { ReactComponent as buy } from 'assets/svg/buy.svg'
// import { ReactComponent as store } from 'assets/svg/store.svg'
// import { ReactComponent as task } from 'assets/svg/task.svg'

const ICONS: Record<string, any> = {
  // buy,
  // store,
  // task,
}

type OriginMenuItemType = ItemType<OrgMenuItemType>

// type OriginMenuItemType = Parameters<typeof AntdMenu>[0]['items'][number]

type MenuItemType = OriginMenuItemType & {
  parent?: MenuItemType
  children?: MenuItemType[]
  title?: string
}

export function Menu() {
  const [menus, setMenus] = useState<MenuItemType[]>([])
  const { config, collapsed, setBaseBreadcrumb } = useLayout()
  const location = useLocation()

  const { pathname } = location

  // const matchPath = useMatch(pathname)

  const [selectedKeys, setSelectedKeys] = useState<string[]>([pathname])
  const [openKeys, setOpenKeys] = useState<string[]>([])

  useEffect(() => {
    if (menus && menus.length) {
      const findMatchedMenus = (
        menus: MenuItemType[],
        pathname: string,
        // opened: MenuItemType[] = [],
        selected: MenuItemType[] = []
      ) => {
        menus.forEach((menu) => {
          const matched = matchPath(
            {
              path: menu.key as string,
              caseSensitive: false,
              end: false,
            },
            pathname
          )

          const hasChildren = !!(menu as MenuItemGroupType).children

          findMatchedMenus(
            menu.children || [],
            pathname,
            // opened,
            selected
          )

          if (matched && !hasChildren) {
            selected.push(menu)
          }
        })

        return selected
      }

      const selectedMenus = findMatchedMenus(menus, pathname)

      // console.log('selectedMenus', selectedMenus)

      const nextOpenKeys: any[] = []
      const nextSelectedKeys: any[] | ((prevState: string[]) => string[]) = []
      const breadcrumbs: BreadcrumbItemType[] = []
      selectedMenus.forEach((menu) => {
        let parent = menu.parent
        while (parent) {
          breadcrumbs.push({
            key: parent.key,
            title: parent.title,
          })
          nextOpenKeys.push(parent.key)
          parent = parent.parent
        }

        breadcrumbs.push({
          key: menu.key,
          title: menu.title,
        })

        nextSelectedKeys.push(menu.key)
      })

      // console.log('openKeys', openKeys, nextOpenKeys)
      // console.log('selectedKeys', selectedKeys, nextSelectedKeys)
      setBaseBreadcrumb(breadcrumbs)
      setOpenKeys((prev) => Array.from(new Set([...prev, ...nextOpenKeys])))
      setSelectedKeys(nextSelectedKeys)
    }
  }, [pathname, menus])

  const updateMenu = useCallback(
    (tree: api.rbac.user.navigation.PermissionTreeVo[]) => {
      const transformItem = (
        node: api.rbac.user.navigation.PermissionTreeVo,
        parent?: MenuItemType
      ): MenuItemType => {
        let pageConfig
        try {
          pageConfig = JSON.parse(node.pageConfig)
        } catch (e) {}

        const Icon = ICONS[pageConfig?.icon as string]

        // TODO ICON 配置
        const hasChildren = node.subPermissions && node.subPermissions.length
        const current: MenuItemType = {
          label: hasChildren ? (
            node.permissionName
          ) : (
            <Link
              to={node.uri}
              target={/^http/.test(node.uri) ? '_blank' : '_self'}
            >
              {node.permissionName}
            </Link>
          ),
          icon: Icon ? <Icon /> : null,
          title: node.permissionName,
          key: node.uri,
          children: hasChildren ? [] : undefined,
          parent,
        }

        if (node.subPermissions && node.subPermissions.length) {
          current.children?.push(
            ...node.subPermissions.map((sub) => transformItem(sub, current))
          )
        }

        return current
      }
      const items = tree.map((item) => transformItem(item))

      setMenus(items)
    },
    []
  )

  const loadMenu = useCallback(async () => {
    const result = await get<api.rbac.user.navigation.PermissionTreeVo[]>({
      url: '/rbac/user/permissionTree',
      query: {
        appCode: config.appCode,
        uri: 'ec_web',
        showTypes: 'NAVIGATION',
        filterNoPermission: true,
      },
    })
    if (result.code === 0 || result.code === 200) {
      // updateMenu(result.data)
      // console.log('menu', result.data)
      updateMenu(result.data[0].subPermissions)
    }
  }, [config.appCode])

  useEffect(() => {
    loadMenu()
  }, [config.appCode])

  // console.log('location', location, openKeys, selectedKeys)

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            itemBg: 'transparent',
            itemHeight: 38,
          },
        },
      }}
    >
      <AntdMenu
        mode='inline'
        // theme='dark'
        items={menus}
        inlineCollapsed={collapsed}
        openKeys={openKeys}
        selectedKeys={selectedKeys}
        onOpenChange={setOpenKeys}
      />
    </ConfigProvider>
  )
}
